<template>
  <div>
    <Loading :loading="!acoes" />
    <md-table v-if="acoes">
      <md-table-row>
        <md-table-head>Ação</md-table-head>
        <md-table-head>Atualizado em</md-table-head>
        <md-table-head v-if="canCancel"> Cancelar </md-table-head>
        <md-table-head v-if="!canCancel"> Origem </md-table-head>
        <md-table-head v-if="!canCancel"> Status </md-table-head>
      </md-table-row>

      <md-table-row v-for="acao in acoes" :key="acao.id">
        <md-table-cell>{{ acao.acaoNome || acao.acao }}</md-table-cell>
        <md-table-cell>{{
          formatDate(acao.executadoEm) || formatDate(acao.criadoEm)
        }}</md-table-cell>
        <md-table-cell v-if="!canCancel">
          {{ getOrigemString(acao.origem) }}
        </md-table-cell>
        <md-table-cell v-if="!canCancel">
          <show-acao-status :value="acao.status" />
        </md-table-cell>
        <md-table-cell v-if="canCancel">
          <md-button
            class="md-accent"
            @click.prevent="dialogActive = true"
            @click="dialogData = acao.id"
          >
            Cancelar Ação
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-dialog-confirm
      :md-backdrop="true"
      :md-active.sync="dialogActive"
      md-title="Tem certeza?"
      md-content="Cancelar uma ação pode não funcionar caso o equipamento já tenha lido o comando"
      md-confirm-text="enviar"
      md-cancel-text="cancelar"
      @md-confirm="() => cancelarAcao(dialogData)"
    />
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { validationMixin } from 'vuelidate'

import ShowAcaoStatus from '@/components/ShowAcaoStatus.vue'
import { getOrigemString } from '@/utils/transform'

import Loading from '../../components/Loading'
import http from '../../utils/http'

export default {
  name: 'EquipamentoAuditoriaTab',
  components: { ShowAcaoStatus, Loading },
  mixins: [validationMixin],
  props: {
    equipamentoId: String,
    status: Array,
    canCancel: Boolean,
  },
  data() {
    return {
      acoes: null,
      dialogData: null,
      dialogActive: false,
    }
  },
  methods: {
    getOrigemString,
    searchAcoes(id) {
      const stringStatus = this.status
        .reduce((acc, e) => acc + '&' + 'status=' + e, '')
        .substr(1)

      http.get(`equipamento/${id}/acao?` + stringStatus).then((e) => {
        this.acoes = e.paged.results
      })
    },
    async cancelarAcao(id) {
      await http.put(`equipamento/acao`, {
        acaoId: id,
      })

      this.searchAcoes(this.equipamentoId)
    },
    formatDate(string) {
      if (!string) {
        return ''
      }

      return moment
        .tz(string, 'UTC')
        .tz(moment.tz.guess())
        .format('D/MM/YYYY à\\s H:mm:ss')
    },
    getStatusString(tinyint) {
      // EsperandoExecucao,
      // Executado,
      // Cancelado,
      // Expirado

      switch (tinyint) {
        case 0:
          return 'Aguardando solicitação do Equipamento'
        case 1:
          return 'Executado'
        case 2:
          return 'Cancelado'
        case 3:
          return 'Enviado para Equipamento'
        case 4:
          return 'Não Enviado'
        case 5:
          return 'Expirado'
      }
    },
    async searchUser(userId, index) {
      const newValue = { ...this.acoes[index] }
      newValue.user = await http.get(`accounts/user/${userId}`)

      this.acoes.splice(index, 1, newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}
</style>
